var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"mx-auto mt-5",attrs:{"cols":"12","sm":"10","md":"9","lg":"7"}},[_c('VirtualForm',{attrs:{"entityType":_vm.$route.params.entityType,"entityId":_vm.$route.params.entityId}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }